export interface BuildInfo {
  gitSha: string;
  buildTime: string;
}

export const getBuildInfo = (environment: Record<string, string | undefined>): BuildInfo => ({
  gitSha: environment.REACT_APP_GIT_SHA || "unknown",
  buildTime: environment.REACT_APP_BUILD_TIME || "unknown",
});

export const buildInfo = getBuildInfo(process.env);
